<div class="token-card">
    <div class="inline-vertical-align">
        <div class="monetization">
            <mat-icon *ngIf="!tokenIcon" fontSet="material-icons-round" class="token-icon-font">monetization_on</mat-icon>
            <img *ngIf="tokenIcon" class="token-icon" [src]="tokenIcon" alt="token image">
            <div class="token-name-container">
                <span class="token-name">{{ mainToken ? mainToken : 'Tokens' }}</span>
            </div>
        </div>
        <div class="info">
            <span class="gray-label">{{ 'tokenInformation.quoteDay' | translate }}</span>
            <span class="bold-value">R$ {{ toNumber(quoteDay) | number:'1.2-4' }}</span>
        </div>
    </div>

    <div class="inline-vertical-align">
        <div class="info">
            <span class="gray-label">{{ 'tokenInformation.tokenBalance' | translate }}</span>
            <span class="bold-value">{{ toNumber(tokens) | number:'1.2-4' }}</span>
        </div>

        <div class="info">
            <span class="gray-label">{{ 'tokenInformation.moneyBalance' | translate }}</span>
            <span class="bold-value">R$ {{ toNumber(money) | number:'1.2-4' }}</span>
        </div>
    </div>
</div>
